<!-- Navbar -->
<div class="navbar" [ngClass]="isExternal ? 'justify-content-end' : ''">
  <img
    class="img-fluid"
    src="assets/images/main_logo.svg"
    alt="Covnia Logo"
    *ngIf="!isExternal"
  />

  <div
    class="fullscreen_icon btn btn-default pointer p-2"
    *ngIf="!router.url.includes('feedback')"
    (click)="fullScreen ? closeFullscreen() : openFullscreen()"
  >
    <em
      class="bi"
      [ngClass]="fullScreen ? 'bi-fullscreen-exit' : 'bi-fullscreen'"
    ></em>
  </div>
</div>
<!-- END Navbar -->
<!-- <div
  class="btn btn-default pointer p-2 d-flex justify-content-center align-items-center"
  *ngIf="!router.url.includes('feedback') && isExternal"
  (click)="fullScreen ? closeFullscreen() : openFullscreen()"
>
  <em
    class="bi"
    [ngClass]="fullScreen ? 'bi-fullscreen-exit' : 'bi-fullscreen'"
  ></em>
</div> -->
